import { Component, OnInit } from '@angular/core';
import { CoreCardBaseComponent } from '../../shared/core-card-base.component';

@Component({
  selector: 'cu-dynamic-card-review',
  templateUrl: './dynamic-card-review.component.html'
})
export class DynamicReviewCardComponent extends CoreCardBaseComponent implements OnInit {
  ngOnInit() {}
}
